// import type { Database } from '@/types/database.types'

export default defineNuxtRouteMiddleware(async (to) => {
  const { profile, isSupplier } = useUserStoreSsr()

  if (!profile.value) {
    const cookies = useCookie('redirect')
    cookies.value = to.path
    return navigateTo({ name: 'login' })
  }

  if (
    to.name !== 'plattform-registrieren' &&
    (!profile.value?.first_name || !profile.value?.last_name)
  ) {
    return navigateTo({ name: 'plattform-registrieren' })
  }

  if (to.name === 'plattform-dashboard') {
    if (!isSupplier.value) return navigateTo({ name: 'plattform-requests' })
  }

  if (to.name === 'plattform-become-supplier') {
    if (isSupplier.value) return navigateTo({ name: 'plattform-marketplace' })
  }

  if (to.name === 'plattform-marketplace') {
    if (!isSupplier.value) return navigateTo({ name: 'plattform-requests' })
  }
})
